module.exports = __webpack_public_path__ + "static/ola-1db1731152c48aa580bdd98f0f757809.jpg";